export const SPONSOR_ACTIONS = {
    SET_SPONSOR: "SET_SPONSOR",
    SET_IS_LOADING: "SET_IS_LOADING",
}